import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'


let RINGING_LIST =`${BASE_URL}/ringing/list`
let RINGING_BASE64 = `${BASE_URL}/ringing/getBase64`
let GET_RINGING = `${BASE_URL}/getRinging`

export async function GetRingingList(params) {
  return request(RINGING_LIST, METHOD.GET, params)
}

export async function GetBase64(params) {
  return request(RINGING_BASE64, METHOD.POST, params)
}

export async function GetRingingFile(filename) {
  // 将文件名动态拼接到请求 URL 中
  const url = `${GET_RINGING}/${filename}`
  return request(url, METHOD.GET,null,{
    responseType: 'arraybuffer'
  })
}

export default {
}
